function canUseStorage(storage) {
  try {
    return typeof storage?.getItem === 'function';
  } catch {
    return false;
  }
}

function safeGetItem(storage, key) {
  if (!canUseStorage(storage)) return null;
  try {
    const value = storage.getItem(key);
    return value === '' ? null : value;
  } catch {
    return null;
  }
}

function safeSetItem(storage, key, value) {
  if (!canUseStorage(storage)) return;
  try {
    storage.setItem(key, value);
  } catch {
    return;
  }
}

function safeRemoveItem(storage, key) {
  if (!canUseStorage(storage)) return;
  try {
    storage.removeItem(key);
  } catch {
    return;
  }
}

export function getRememberMeChecked() {
  const raw = safeGetItem(localStorage, 'isRememberMeChecked');
  if (raw === null) return false;
  if (raw === true || raw === false) return raw;
  return raw === 'true';
}

export function getStoredValue(key) {
  return safeGetItem(localStorage, key) ?? safeGetItem(sessionStorage, key);
}

export function getAuthStoredValue(key) {
  const rememberMe = getRememberMeChecked();
  if (rememberMe) {
    return safeGetItem(localStorage, key) ?? safeGetItem(sessionStorage, key);
  }
  return safeGetItem(sessionStorage, key) ?? safeGetItem(localStorage, key);
}

export function setAuthStoredValue(key, value) {
  const rememberMe = getRememberMeChecked();
  const normalized = value == null ? '' : String(value);
  if (rememberMe) {
    safeSetItem(localStorage, key, normalized);
    safeRemoveItem(sessionStorage, key);
  } else {
    safeSetItem(sessionStorage, key, normalized);
    safeRemoveItem(localStorage, key);
  }
}

export function removeAuthStoredValue(key) {
  safeRemoveItem(localStorage, key);
  safeRemoveItem(sessionStorage, key);
}
